import {
    productCode118,
    productCodeBamboo,
    productCodeBudgetMoney,
    productCodeCoopPlata,
    productCodeFluro,
    productCodePlata,
} from '@ilg-totallymoney/cardloanutils'

export const supportedSameDayDepositLoanIds = [
    productCode118,
    productCodeBamboo,
    productCodeBudgetMoney,
    productCodeCoopPlata,
    productCodeFluro,
    productCodePlata,
]

export const canShowSameDayDepositBadge = (loanId: string) =>
    supportedSameDayDepositLoanIds.includes(loanId)
